import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";

const ClientStatistics = (props) => {
    const { match, location } = props;
    const rootUrl = `${match.path}/list`;

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} isTable transition="full" nofilter title="Статистика клиентов" />}
                />
            </Switch>
        </div>
    );
};

export default ClientStatistics;
